import { render, staticRenderFns } from "./ProjectCard.vue?vue&type=template&id=ddd54b5e&scoped=true"
import script from "./ProjectCard.vue?vue&type=script&lang=js"
export * from "./ProjectCard.vue?vue&type=script&lang=js"
import style0 from "./ProjectCard.vue?vue&type=style&index=0&id=ddd54b5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddd54b5e",
  null
  
)

export default component.exports